export const MIN_ANNOUNCEMENT_READ_TIME_IN_MS = 1000 as const;
export const ESTIMATED_CHARACTER_READ_TIME_IN_MS = 50 as const;
